(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) { instances.get(root).update(); return; }
    const controller = new AbortController();
    instances.set(root, { controller, update });
    const options = { signal: controller.signal };
    const image = root.querySelector('[data-lm-main-image]');
    root.querySelectorAll('[data-lm-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        if (image) {
          image.removeAttribute('srcset');
          image.src = button.dataset.src;
          image.alt = button.dataset.alt || '';
        }
        root.querySelectorAll('[data-lm-thumb]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      }, options);
    });
    const variant = root.querySelector('[data-lm-variant]');
    const cards = [...root.querySelectorAll('[data-lm-card]')];
    const form = root.querySelector('.lm-product-form');
    const currency = root.dataset.currency || 'CLP';
    const moneyFormatter = new Intl.NumberFormat(root.dataset.locale === 'es' ? 'es-CL' : root.dataset.locale || 'es-CL', {style:'currency',currency,maximumFractionDigits:currency === 'CLP' ? 0 : 2});
    const money = cents => moneyFormatter.format(cents / 100);
    const fill = (template, values) => Object.entries(values).reduce((text,[key,value]) => text.replaceAll('__'+key+'__', String(value)), template);
    const paint = (card, selector, text, visible=true) => {
      const element=card.querySelector(selector);
      if(element){ element.textContent=text; element.hidden=!visible; }
    };
    function update() {
      if (root.querySelector('.lm-lunar-cod-layout')) return;
      const data = variant?.selectedOptions?.[0]?.dataset || variant?.dataset || {};
      const unit = Number(data.price ?? root.dataset.unitPrice);
      const compare = Math.max(unit, Number(data.compare ?? root.dataset.comparePrice) || 0);
      const min = Number(data.min) || 1;
      const increment = Number(data.increment) || 1;
      const max = data.max ? Number(data.max) : Infinity;
      const inventory = data.inventory !== undefined && data.inventory !== '' ? Number(data.inventory) : Infinity;
      cards.forEach(card => {
        const quantity = Number(card.dataset.quantity);
        const base = unit * quantity;
        const configured = quantity === 2 ? Number(root.dataset.discountTwo) : quantity === 3 ? Number(root.dataset.discountThree) : 0;
        const reduction = Math.min(base, Math.max(0, currency === 'CLP' ? configured || 0 : 0));
        const total = base - reduction;
        const reference = (root.querySelector('.lm-pet-packs') && quantity > 1 ? unit : compare) * quantity;
        const saved = reference - total;
        const percentage = reference > 0 ? Math.round(saved / reference * 1000) / 10 : 0;
        const radio = card.querySelector('[data-lm-choice]');
        radio.disabled = data.available === 'false' || quantity < min || quantity > max || quantity > inventory || quantity % increment !== 0;
        if (radio.disabled) radio.checked = false;
        card.dataset.total = String(total);
        paint(card,'[data-lm-card-total]',money(total));
        paint(card,'[data-lm-card-reference]',money(reference),reference>total);
        paint(card,'[data-lm-each]',fill(root.dataset.eachTemplate,{price:money(total/quantity)}));
        paint(card,'[data-lm-saving]',fill(root.dataset.saveTemplate,{amount:money(saved),percent:percentage.toLocaleString(root.dataset.locale || 'es-CL')}),saved>0);
        paint(card,'[data-lm-volume]',fill(root.dataset.volumeTemplate,{amount:money(reduction)}),reduction>0);
        const unavailable=card.querySelector('[data-lm-unavailable]');
        if(unavailable) unavailable.hidden=!radio.disabled;
      });
      let selected = root.querySelector('[data-lm-choice]:checked');
      if(!selected) {
        selected=root.querySelector('[data-lm-choice]:not(:disabled)');
        if(selected) selected.checked=true;
      }
      const quantity = Number(selected?.value || 1);
      const total = Number(selected?.closest('[data-lm-card]')?.dataset.total ?? unit);
      root.querySelectorAll('[data-lm-pack-total]').forEach(el=>el.textContent=money(total));
      root.querySelectorAll('[data-lm-selected-count]').forEach(el=>el.textContent=quantity===1?root.dataset.oneLabel:fill(root.dataset.countTemplate,{count:quantity}));
      root.querySelectorAll('[data-lm-unit-price]').forEach(el=>el.textContent=money(unit));
      const reference=root.querySelector('[data-lm-unit-compare]');
      if(reference){reference.textContent=money(compare);reference.hidden=compare<=unit;}
      const buy=root.querySelector('[data-lm-checkout]');
      if(buy) {
        buy.hidden=!selected;
        buy.href=(window.Shopify?.routes?.root || '/')+'cart/'+encodeURIComponent(variant.value)+':'+quantity;
      }
      form?.querySelectorAll('button[type="submit"]').forEach(button=>button.disabled=!selected);
    }
    root.querySelectorAll('[data-lm-choice]').forEach(radio=>radio.addEventListener('change',update,options));
    variant?.addEventListener('change',()=>{
      const stock=root.querySelector('[data-lm-stock]');
      if(stock)stock.hidden=true;
      update();
    },options);
    update();
    const timer=root.querySelector('[data-lm-countdown]');
    if(timer){
      const until=Date.parse(timer.dataset.until);
      const tick=()=>{
        const ms=until-Date.now();
        if(!Number.isFinite(until)||ms<=0){timer.hidden=true;return false;}
        const h=Math.floor(ms/3600000),m=Math.floor(ms%3600000/60000),s=Math.floor(ms%60000/1000);
        const output=timer.querySelector('b');
        if(output)output.textContent=[h,m,s].map(v=>String(v).padStart(2,'0')).join(':');
        return true;
      };
      if(tick()){
        const interval=setInterval(()=>{if(!root.isConnected||!tick())clearInterval(interval);},1000);
        controller.signal.addEventListener('abort',()=>clearInterval(interval),{once:true});
      }
    }
  }
  const run = () => document.querySelectorAll('[data-lm-product]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  window.addEventListener('pageshow',()=>requestAnimationFrame(run));
  document.addEventListener('shopify:section:load',run);
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('[data-lm-product]').forEach(root=>{instances.get(root)?.controller.abort();instances.delete(root);});
  });
})();
